module.exports = __webpack_public_path__ + "img/logos.45f32b5b.png";